import React from 'react'
import { createGlobalStyle, ThemeProvider as SCThemeProvider } from 'styled-components'
import { MARKETUP } from './marketup'

export type Theme = typeof MARKETUP
export const DEFAULT_THEME = MARKETUP

const GlobalStyle = createGlobalStyle`
  body {
    // viewport
    height: 100vh;
    width: 25.875rem;
    
    // global styles
    color: ${props => props.theme.colors.text};
    font-size: 16px;
    line-height: 1.5;
  }
  html,
  body,
  div,
  form,
  fieldset,
  legend,
  caption,
  label,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre
  {
    font-size: 100%;
    font-weight: normal;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
    border: 0;
    outline: 0;
    background: transparent;
    box-sizing: border-box;
  }

  table
  {
    border-spacing: 0;
    border-collapse: collapse;
  }

  th,
  td
  {
    text-align: left;
    vertical-align: top;
  }

  img
  {
    border: 0;
  }

  // antd mobile variables
  :root:root {
    --adm-color-primary: ${props => props.theme.colors.theme};
  }
`

export const ThemeProvider: React.FC<{ theme?: Theme }> = ({ theme, children }) => {
  return (
    <SCThemeProvider theme={theme ?? DEFAULT_THEME}>
      <GlobalStyle />
      {children}
    </SCThemeProvider>
  )
}

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {
  }
}
